module.exports = __webpack_public_path__ + "img/banner2.95f471b7.jpg";